import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import "./Header.scss";

import lotteMartLogo from "../../images/icon/logo_lottemart_2x.png";
import iconBack from "../../images/icon/icon-goback.png";
import kioskStartGif from "../../images/gif/kiosk_start_pay.gif";
import kioskAddItemGif from "../../images/gif/kiosk_add_item.gif";

export default function Header(props) {
  function getDate() {
    let datetime = new Date();
    const [year, month, day] = datetime.toLocaleDateString().split(".");
    return `${Number(year)}-${String(Number(month)).padStart(2, "0")}-${String(
      Number(day)
    ).padStart(2, "0")}`;
  }

  function getTime() {
    let datetime = new Date();
    const [hh, mm, ss] = [
      String(datetime.getHours()).padStart(2, "0"),
      String(datetime.getMinutes()).padStart(2, "0"),
      String(datetime.getSeconds()).padStart(2, "0"),
    ];
    return `${hh}:${mm}:${ss}`;
  }

  const [time, setTime] = useState(getTime());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(getTime());
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <>
      <div className="header">
        <div className="header-left">
          {props.isStart ? (
            <div className="header-left-sco">
              <img className="header-logo" src={lotteMartLogo} alt="logo" />
              <p className="header-nav-sco">{props.scoMsg}</p>
            </div>
          ) : (
            <div className="header-left-sco-larger">
              <Link to={props.linkTo}>
                <img className="header-goback" src={iconBack} alt="go-back" />
              </Link>
              <div className="header-larger">{props.scoMsg}</div>
            </div>
          )}
          <div className="header-nav-kiosk">
            <img className="header-logo" src={lotteMartLogo} alt="logo" />
            <div>
              <p>{props.kioskMsg.split("\r\n")[0]}</p>
              <p>{props.kioskMsg.split("\r\n")[1]}</p>
            </div>
          </div>
        </div>
        {props.scoMsg2 && (
          <div className="header-middle">
            <p>{props.scoMsg2.split("\r\n")[0]}</p>
            <p>{props.scoMsg2.split("\r\n")[1]}</p>
          </div>
        )}
        <div className="header-right">
          <div className="header-info-sco">
            <p className="header-date">날짜: {getDate()}</p>
            <p className="header-time">시간: {time}</p>
          </div>
        </div>
      </div>
      <div className="header-info-kiosk">
        {props.isStart ? (
          <img
            className="header-kiosk-start-gif"
            src={kioskStartGif}
            alt="kiosk-header-gif"
          />
        ) : (
          <img
            className="header-kiosk-add-item-gif"
            src={kioskAddItemGif}
            alt="kiosk-header-gif"
          />
        )}
      </div>
    </>
  );
}
